

// error of unkowen module is bs 

const swiper = new Swiper('.product-swiper', {
    // Optional parameters
  
    slidesPerView: 'auto' ,
    centeredSlides: true,
    mouseWheel: true,
    roundLengths: true,
    loop: true,
    mousewheelControl: true,
    spaceBetween: 10, 
    slideToClickedSlide: true,
   
    
    
  });